import { IAuthTokenEntity } from '../../model/api/auth/token.entity.interface';
import { IAuthCredentialsEntity } from '../../model/api/auth/credentials.entity.interface';
import { IAuthIdentityVerificationEntity } from '../../model/api/auth/identity-verfication.entity.interface';
// import { ISigninEntity } from '../../model/api/auth/signin.entity.interface';
import { IIdentityVerificationResponseEntity } from '../../model/api/auth/identity-verification-response.entity.interface';
import { IApiAuthResponseEntity } from '../../model/api/auth/api-auth-response.entity.interface';
import { ISupportCodeEntity } from '../../model/api/auth/support-code.entity.interface';
import { IPasswordResetEntity } from '../../model/api/auth/password-reset.entity.interface';
import { IRegisterFingerprintEntity } from '../../model/api/auth/register-fingerprint.interface';
import { IRegisterFingerprintResponseEntityCST } from '../../model/api/auth/register-fingerprint-response.interface';
import {
  IAuthToken,
  ISignin,
  IIdentityVerificationResponse,
  IRegisterFingerprint
} from '../../model/models/auth';
import { CustomerMapper } from '../customer/customer.mapper';
import { OTPHeaderResponse } from 'model/models/auth/otp.interface';

export class AuthMapper {
  static fromTokenEntity(entity: IAuthTokenEntity, featureFlags: any): IAuthToken {
    return {
      jwt: entity.jwtToken,
      expiresInSeconds: entity.expiresInSeconds,
      issuedAt: entity.issuedAt,
      type: entity.tokenType,
      refresh: entity.refresh,
      featureFlags,
    };
  }

  // TODO: Updated ISIgninEntity and use it instead of any
  static fromSigninEntity(entity: any): ISignin {
    return {
      authToken: { jwt: entity['access_token'], type: entity['token_type'], issuedAt: entity['.issued'], expiresInSeconds: entity['expires_in'], refresh: entity['refresh_token'], featureFlags: entity['featureFlags'] },
      authenticationResult: { success: true, message: '', links: [], requiresVerification: !entity.HasValidDeviceToken, emailOtpRequired: entity.EmailOTPRequired, requirePhoneUpdate: entity.PhoneUpdateRequired, isSocialAccountLinked: entity.IsSocialAccountLinked },
    }
  }

  static fromIdentityVerificationEnitity(entity: IIdentityVerificationResponseEntity): IIdentityVerificationResponse {
    return {
      deviceToken: entity.deviceToken,
      customerProfile: CustomerMapper.fromCustomerEntity(entity.customerProfile),
    }
  }

  /**
   * @description One-off because the username differs from what we get back
   * from the dynamic form field response  (womp womp) , and we need to make sure
   * we include deviceId and deviceToken.
   * @param model
   */
  static toCredentialsEntity(model: any): IAuthCredentialsEntity {
    return {
      username: model.emailAddress,
      password: model.password,
      deviceId: model.deviceId,
      deviceToken: model.deviceToken || null,
      fingerPrint: model.fingerPrint
    };
  }

  static toIdentityVerifcationEntity(model: any): IAuthIdentityVerificationEntity {
    return {
      question: model.userSecurityQuestion,
      answer: model.securityQuestionAnswer1,
      deviceId: model.deviceId || 'DEVICEID',
      emailAddress: model.emailAddress,
      securityCode: model.securityCode
    }
  }

  static toSupportCodeEntity(model: any) : ISupportCodeEntity {
    return {
      supportCode: model.supportCode,
      deviceId: model.deviceId,
      customerIdentifier: model.emailAddress,
    }
  }

  static toPasswordResetEntity(model: any) : IPasswordResetEntity {
    return {
      securityCode: model.securityCode,
      newPassword: model.newPassword
    }
  }

  static toRegisterFingerprintEntity(model:any) : IRegisterFingerprintEntity {
    return {
      username: model.emailAddress,
      password: model.password,
      deviceId: model.deviceId,
      deviceToken: model.deviceToken
    };
  }

  static fromRegisterFingerprintResponseEntity(entity: IRegisterFingerprintResponseEntityCST): IRegisterFingerprint {
    return {
      fingerPrint: entity.FingerPrint
    };
  }

  static fromOtpHeader(model: any): OTPHeaderResponse {
    return {
      otpCode: model.otpcode,
      securityCode: model.securitycode,
      referenceValue: model.referencevalue,
      maskedPhone: model.maskedphone,
      maskedEmail: model.maskedemail,
      sessionKey: model.sessionkey,
      OTPRemainingAttempts: model.otpremainingattempts,
      waitingOtpTime: model.waitingotptime,
      otpTimerResponse: model.otpTimerResponse,
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/authorization/auth.mapper.ts